export default __webpack_public_path__ + "static/favicon-fabc7578261c3732e7fcfeffa2ccf55d.ico";